import { NavLink } from "react-router-dom"

const CustomNavLink = (onClick: () => void) => (props: any) => {
  return (<NavLink onClick={onClick} {...props} />)
}

export default CustomNavLink;